import { render, staticRenderFns } from "./AppointmentModal.vue?vue&type=template&id=492a01f8&scoped=true"
import script from "./AppointmentModal.vue?vue&type=script&lang=js"
export * from "./AppointmentModal.vue?vue&type=script&lang=js"
import style0 from "./AppointmentModal.vue?vue&type=style&index=0&id=492a01f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492a01f8",
  null
  
)

export default component.exports